<!-- 分页模块 -->
<template>
  <div class="paging">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPages"
      :page-sizes="pageSizes"
      :page-size="size"
      :pager-count="5"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
      ref="pagination"
    ></el-pagination>
  </div>
</template>

<script>
// import minxin from "../../../assets/javascript/minxin.js";
export default {
  props: ["totalCount", "pageSize","showSize",  "currentPage"],
  // mixins: [minxin],
  data() {
    return {
      currentPages: this.currentPage
    };
  },
  computed: {
    size() {
      return this.showSize ? this.showSize : 20;
    },
    pageSizes () {
        return this.pageSize ? [100] : [10, 20, 50, 80, 100];
    }
  },
  watch: {
    currentPage() {
      if (this.currentPage == 1) {
        this.$nextTick(() => {
          this.$refs.pagination.internalCurrentPage = 1;
        });
      }
    }
  },
  created() {},

  methods: {
    handleCurrentChange(val) {
      this.$emit("doPageQuery", {
        type: "start",
        start: val
      });
    },
    handleSizeChange(val) {
      this.$emit("doPageQuery", {
        type: "size",
        size: val
      });
    }
  }
};
</script>
<style lang="less" scoped>
.paging {
  // padding-top: 13px;
  background: #fff;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 16px 0;
}

.el-input,
.el-input--small .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
}
// /deep/ .el-input__suffix .el-input__icon {
//   height: 75%;
// }
</style>
